import React from "react";

const Foorer = () => {
  return (
    <footer className="bg-[#151515] py-8 sm:py-10 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0 text-center md:text-left">
            <img
              src="/assets/ilsa_logo-w.png"
              alt="ilsa logo"
              className="h-8 mb-2 mx-auto md:mx-0"
            />
            <p className="text-sm text-white leading-7">
              <span className="font-bold mr-3">넷스프린트</span>
              대표이사: 권영남
              <br className="md:hidden" />
              <span className="hidden md:inline mx-2"></span>
              사업자등록번호: 173-87-02840
              <br />
              서울시 중구 청계천로 100 시그니쳐타워 1015호
              <br className="md:hidden" />
              <span className="hidden md:inline mx-2"></span>
              이메일: customer@ilsaram.co.kr
              <br className="md:hidden" />
              <span className="hidden md:inline mx-2"></span>
              전화번호: 1566-1013
            </p>
          </div>
        </div>
        <p className="text-xs text-[#9E9E9E] mt-5 text-center md:text-left">
          © netsprint Inc. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Foorer;
